import styled from 'styled-components'

export const TableCell = styled.td<{ columnId: string; $rowHeight: number; $withBorder?: boolean }>`
  background-color: ${props => props.theme.colors.white.base};
  padding: ${props => props.theme.spacings.small};
  text-align: left;
  border-bottom: 2px solid ${props => props.theme.colors.neutral.lighter};
  width: calc(var(--col-${props => props.columnId}-size) * 1px);

  display: flex;
  align-items: center;
  height: ${props => props.$rowHeight}px;
  min-height: ${props => props.$rowHeight}px;
  &:not(:last-child) {
    border-right: 2px solid
      ${props =>
        props.$withBorder ? props.theme.colors.neutral.lighter : props.theme.colors.white.base};
  }

  &[data-cell-selectable='true'] {
    cursor: pointer;
  }

  &[data-selected='true'] {
    position: relative;
    background-color: ${props => props.theme.colors.primary.lightest};
    box-shadow: inset 0 0 0 2px ${props => props.theme.colors.primary.base};

    &:before {
      content: '';
      position: absolute;
      height: 13px;
      width: 14px;
      right: 0;
      top: 1px;
      border-bottom-left-radius: ${props => props.theme.dimensions.borderRadius};
      background-color: ${props => props.theme.colors.primary.base};
    }

    [data-e2e='data-table-cell-selected--icon'] {
      position: absolute;
      height: 9px;
      width: 9px;
      right: 2px;
      top: 2px;
      z-index: 1;
      color: white;
    }
  }
`
